import React from "react"
import styled from "react-emotion"
import { Icon, Label, Section } from "ui"

const MenuSection = (label, props = {}) => ({ children, toggle, isOpen }) => {
    const Bar = styled("div")`
        padding: 4px 8px;
        border: 1px solid #494d58;
        border-left: none;
        border-right: none;
        background: #2c313c;
        font-weight: bold;
    `

    return (
        <div>
            <Bar onClick={toggle}>
                <Label>
                    <Icon icon={isOpen ? "caret-down" : "caret-right"} margin="medium" />
                    {label}
                </Label>
            </Bar>
            {isOpen && (
                <Section padding={props.padding || "medium"} margin={props.margin}>
                    {children}
                </Section>
            )}
        </div>
    )
}

export default MenuSection



// WEBPACK FOOTER //
// ./src/features/editor/ui/MenuSection.js